// src/pages/BranchTransactionOutward/index.js
import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { PrinterOutlined } from "@ant-design/icons";
import { App, Button, Card, Grid, Typography } from "antd";
import BranchTransactionOutwardFilters from "./components/BranchTransactionOutwardFilters";
import BranchTransactionOutwardTable from "./components/BranchTransactionOutwardTable";
import ReportDom from "../../../components/common/ReportDom";
import { useReactToPrint } from "react-to-print";

const { Title } = Typography;

const BranchTransactionOutward = () => {
  const { message } = App.useApp();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { filters } = useSelector((state) => state.branchTransactionOutward);
  const reportRef = useRef(null);

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Branch Transaction Outward Report",
    removeAfterPrint: true,
  });

  return (
    <div className="p-4">
      <App>
        <Card
          className="shadow-md rounded-xl mb-4"
          title={
            <Title level={4} style={{ margin: 0 }} className="reportBigTitle" >
              Branch Transaction Outward
            </Title>
          }
          extra={
            <Button
              type="primary"
              icon={<PrinterOutlined />}
              onClick={handlePrint}
            >
              { !screens.xs && "Print" }
            </Button>
          }
          styles={{
            header: { borderBottom: "none", padding: "12px 16px" },
            body: { padding: 0 },
          }}
        />

        <BranchTransactionOutwardFilters messageApi={message} />

        <Card className="shadow-md rounded-xl">
          <BranchTransactionOutwardTable />
        </Card>
      </App>

      {/* Hidden Print Layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <ReportDom
          ref={reportRef}
          title="Branch Transaction Outward"
          mode="report-page"
          filters={filters}
          renderTable={() => (
            <BranchTransactionOutwardTable pagination={false} printMode />
          )}
        />
      </div>
    </div>
  );
};

export default BranchTransactionOutward;
